import React from "react";
import PropTypes from 'prop-types';
import {graphql, useStaticQuery} from "gatsby";
import {MuiThemeProvider, createMuiTheme} from "@material-ui/core";

const query = graphql`
    query {
        site {
            siteMetadata {
                theme {
                    primary
                    secondary
                }
            }
        }
    }
`;

export const Theme = (props) => {
    const data = useStaticQuery(query);

    const theme = createMuiTheme({
        palette: {
            primary: { main: data.site.siteMetadata.theme.primary },
            secondary: { main: data.site.siteMetadata.theme.secondary }
        },
        typography: {
            h1: {
                fontSize: 40,
            },
            h2: {
                fontSize: 36,
            },
            h3: {
                fontSize: 33,
            },
            h4: {
                fontSize: 30,
            }
        }

    })

    return <MuiThemeProvider theme={theme}>
        {props.children}
    </MuiThemeProvider>
};

Theme.propTypes = {
    children: PropTypes.node.isRequired,
};